import { eEstadoContratista } from "../common/enumModel";
import { IContratistaModel } from "../interfaces/contratista/IContratistaModel";

export class ContratistaModel implements IContratistaModel {
    idContratista : number;
    nombre : string;
    estado: string;
    ruc: string;
    idEstado: eEstadoContratista;
    selectedSedes: number[];
    selectedCompanias: number[];
    nombreSedes: string;
    nombreCompanias: string;
    
    constructor(){
        this.idContratista = 0;
        this.nombre = '';
        this.estado = '';
        this.ruc = '';
        this.idEstado = eEstadoContratista.ACTIVO;
        this.selectedSedes = new Array<number>();
        this.selectedCompanias = new Array<number>();
        this.nombreSedes = '';
        this.nombreCompanias = '';
    }
}